import React, { useEffect } from 'react';
import Info from './Info';
import { css } from '@emotion/css';
import Hours from './Hours';
import Prices from './Prices';
import Impressum from './Impressum';
import { Route, Routes, useLocation } from 'react-router-dom';

function Content() {
  const location = useLocation();

  useEffect(() => navigate(location.pathname));

  return (
    <div className={style.container}>
      <Routes>
        <Route path="/impressum" element={<Impressum />} />
        <Route
          path="*"
          element={
            <React.Fragment>
              <Info />
              <Hours />
              <Prices />
            </React.Fragment>
          }
        />
      </Routes>
    </div>
  );
}

function navigate(path: string) {
  if (path === '/' || path === '/impressum') {
    window.scrollTo(0, 0);
    return;
  }
  const id = path?.substring(1);
  const position = document.getElementById(id)?.offsetTop;
  if (position) {
    window.scrollTo(0, Math.max(position - 50, 0));
  }
}

const style = {
  container: css`
    padding: 10px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  `,
};

export default Content;
